module.exports = __webpack_public_path__ + "assets/img/faq.85e46cea.svg";